import CartItem         from './components/cart/CartItem.vue';
import CartItemHistory  from './components/cart/CartItemHistory.vue'
import CartItemNote     from './components/cart/CartItemNote.vue';
import CartPromoCode    from './components/cart/CartPromoCode.vue';
import CartOrderNote    from './components/cart/CartOrderNote.vue';
import CartSparkle      from './components/cart/CartSparkle.vue';
import CartTotal        from './components/cart/CartTotal.vue';
import CartTotalCard        from './components/cart/CartTotalCard.vue';
import CartGratuity     from './components/cart/CartGratuity.vue';
import ModalOncePerSession     from './components/cart/ModalOncePerSession.vue';
import NoticeRepresentativeProduct     from './components/cart/NoticeRepresentativeProduct.vue';

import checkoutPlaceOrderButton from './components/checkout/CheckoutPlaceOrderButton'
import checkoutNowButton from './components/checkout/CheckoutNowButton'

import NavigationFooter from './components/NavigationFooter.vue'

import ClosenessQualifier from './components/ClosenessQualifier.vue';
import CouponDetailModal from './components/CouponDetailModal.vue';
import CouponCard from './components/CouponCard.vue';

import ProductCard from './components/product/ProductCard.vue';
import ProductCardCouponPopup from './components/product/ProductCardCouponPopup.vue';
import ProductCollectionHorizontal from './components/product/ProductCollectionHorizontal.vue';
import ProductCollectionSidebar from './components/product/ProductCollectionSidebar.vue';
import ProductDetails from './components/product/ProductDetails.vue';
import ProductList from './components/product/ProductList.vue';

import ReservationDisplay from './components/reservation/Display.vue';
import PastPurchases from './components/PastPurchases.vue';

import Errors from './components/Errors.vue';

import ShoppingListTypeahead from './components/ShoppingListTypeahead.vue';

import GlobalModals from './components/GlobalModals.vue';
import AddToBucket from './components/AddToBucket.vue';
import PreferenceAddToBucket from './components/preferences/PreferenceAddToBucket.vue';

import SmallBasketFeeProgress from './components/SmallBasketFeeProgress.vue';


export default {
    CartItem,
    CartItemHistory,
    CartItemNote,
    CartPromoCode,
    CartOrderNote,
    CartSparkle,
    CartTotal,
    CartTotalCard,
    CartGratuity,
    ModalOncePerSession,
    NoticeRepresentativeProduct,

    checkoutPlaceOrderButton,
    checkoutNowButton,

    NavigationFooter,

    ClosenessQualifier,
    CouponDetailModal,
    CouponCard,

    ProductCard,
    ProductCardCouponPopup,
    ProductCollectionHorizontal,
    ProductCollectionSidebar,
    ProductDetails,
    ProductList,

    Errors,
    PastPurchases,

    ReservationDisplay,

    ShoppingListTypeahead,

    GlobalModals,
    AddToBucket,
    PreferenceAddToBucket,
    SmallBasketFeeProgress
};
